import React from 'react'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { CodigosTransaccionesConstant } from 'constants/index'

import { Portlet, Form, Button, Row, Col } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'
import { DownloadAxiosFile } from 'utils'

const portletBreadcrumbs = [
  { name: 'Asientos Contables', path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}` },
  { name: 'Reportes' },
  { name: 'Balance General' }
]

export const ValidationSchema = Yup.object().shape({
  mes: Yup.string().length(2).required()
})

const FormatoBalanceComprobacion = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      mes: __adminContext.mesTrabajo || ''
    }
  }, [__adminContext])

  const onSubmit = React.useCallback(
    async formData => {
      __zariContext.loader.open('Descargando balance de comprobación ...')
      await AsientoContableService.descargarBalanceGeneral(formData)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header title='Balance General' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        {__adminContext.mesTrabajo && (
          <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
            {({ errors, touched, isSubmitting, values, handleSubmit }) => (
              <Form>
                <Row>
                  <Col md={6}>
                    <Row>
                      <Col md={6}>
                        <FormGroups.MesContabilidadFormGroup
                          iError={errors.mes}
                          iTouched={touched.mes}
                          fIsSubmitting={isSubmitting}
                        />
                      </Col>
                      <Col md={6}>
                        <Button disabled={isSubmitting} onClick={handleSubmit}>
                          {isSubmitting ? 'Descargando reporte ...' : 'Descargar'}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(FormatoBalanceComprobacion)
